export const CHECKBOX_ICON_SIZE = "extra-small";
export const CHECKBOX_FILL_VAR = "--kit-checkbox-icon-fill";
